module.exports = __webpack_public_path__ + "static/media/tip_text_dog_twelveweek_en.8503831e.svg";